import { createRef, h } from "preact";

import SubmitButton from "./SubmitButton.jsx";
import TextField from "./TextField.jsx";

import profileApi from "../api/profile";
import i18n from "../i18n.js";
import { useState } from "preact/hooks";

export default function ChangePasswordForm(props) {
  const formRef = createRef();
  const [sending, setSending] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [password, setPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    setError(null);
    setSending(true);

    try {
      await profileApi.changePassword(currentPassword, password);
      setSuccess(true);
      setCurrentPassword("");
      setPassword("");
      setTimeout(() => {
        setSuccess(false);
      }, 2000);
    } catch (err) {
      setError(err.errors);
    }
    setSending(false);
  }

  return (
    <form onSubmit={handleSubmit} ref={formRef}>
      <TextField
        name="current-password"
        label={i18n.t("pages.settings.security.labels.currentPassword")}
        error={error && error.currentPassword}
        type="password"
        value={currentPassword}
        onChange={(event) => setCurrentPassword(event.target.value)}
      />
      <TextField
        name="password"
        label={i18n.t("pages.settings.security.labels.newPassword")}
        error={error && error.password}
        type="password"
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        revealable
      />

      <p class="mt-48">
        <SubmitButton
          sending={sending}
          success={success}
          disabled={!password || !currentPassword}
        >
          {i18n.t("pages.settings.security.submit")}
        </SubmitButton>
      </p>
    </form>
  );
}
